<div class="container">
  <mat-card appearance="outlined" class="mat-component-background mat-elevation-z2">
    <div class="container-logo">
      <ng-container *ngIf="isImageSaved; else elseTemplate">
        <img [src]="(companyLogoUrl$ | async)" class="logo" alt="company-logo" />
      </ng-container>
      <ng-template #elseTemplate>
        <img [src]="placeholderUrl" class="logo" alt="company-logo"/>
      </ng-template>
    </div>
    <mat-card-actions class="container-actions">
        <div>
            <button type="button" mat-icon-button (click)="fileInput.click()" matTooltip="Upload image"><mat-icon>upload</mat-icon></button>
            <input hidden (change)="fileChangeEvent($event)" #fileInput type="file" id="file" accept=".jpg,.jpeg,.png">
        </div>
    </mat-card-actions>
  </mat-card>
</div>
